export class BroadcastModel {
  id: string;
  message: string;
  active: boolean;
  created: Date;

  constructor(data?: Partial<BroadcastModel>) {
    Object.assign(this, data);
  }
}

export interface UploadUrlResponse {
  uploadUrl: string;
  publicUrl: string;
  fileName: string;
}
